import React, { useCallback, useRef } from 'react'

import { UserContext } from '../../../context'

import { ButtonComponent } from '@/components/commons'
import { ModalPage } from '@/components/ui/modals/ModalPage.component'
import { Subtitle } from '@/components/commons/typography/Subtitle'
import { InputComponent } from '@/components/commons/forms/input/Input.component'
import { REFERRAL_BASE_URL } from '@/shared/consts/pages'

interface ReferralModalProps {
  isOpen: boolean
  onClose: () => void
}

export const ReferralModal: React.FC<ReferralModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { user } = React.useContext(UserContext)
  const buttonRef = useRef(null)

  const copyReferralUrl = useCallback(() => {
    navigator.clipboard.writeText(REFERRAL_BASE_URL + user?.id)

    buttonRef.current.innerText = 'COPIED!'

    setTimeout(() => {
      onClose()
    }, 300)
  }, [user, onClose])

  return (
    <ModalPage
      show={isOpen}
      onClose={onClose}
      className={['full-w']}
      classNameContainer={['full-w']}
    >
      <div>
        <Subtitle className="text-center">
          Send your referral link to a friend so they can skip the waitlist!
        </Subtitle>
        <div className="pt-20 pt-24--tablet">
          <InputComponent
            disabled
            className={['full-w cursor-pointer']}
            onClick={copyReferralUrl}
            value={REFERRAL_BASE_URL + user?.id}
          />

          <ButtonComponent
            className="mt-20"
            fullWidth
            ref={buttonRef}
            size="xSmall"
            label="COPY LINK"
            onClick={copyReferralUrl}
          />
        </div>
      </div>
    </ModalPage>
  )
}
